import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import asyncComponent from '../../helpers/AsyncFunc';

const routes = [
  {
    path: '',
    component: asyncComponent(() => import('../Sau')),
  },
  {
    path: 'sau',
    component: asyncComponent(() => import('../Sau')),
  },
  {
    path: 'sau_search',
    component: asyncComponent(() => import('../Sau/search')),
  },
  {
    path: 'sau_statistics',
    component: asyncComponent(() => import('../Sau/statistics')),
  },
  {
    path: 'control_panel',
    component: asyncComponent(() => import('../controlPanel')),
  },
  {
    path: 'processes',
    component: asyncComponent(() => import('../Process')),
  },
  {
    path: 'process_group/:id',
    component: asyncComponent(() => import('../Processes')),
  },
  {
    path: 'sector/:id',
    component: asyncComponent(() => import('../Sector')),
  },
  {
    path: 'files',
    component: asyncComponent(() => import('../Files')),
  },
  {
    path: 'subprocesses',
    component: asyncComponent(() => import('../SubProcesses')),
  },
  {
    path: 'process/:id',
    component: asyncComponent(() => import('../Processes/Process')),
  },
  {
    path: 'subprocess/:id',
    component: asyncComponent(() => import('../SubProcesses/SubProcess')),
  },
  {
    path: 'charges',
    component: asyncComponent(() => import('../Charges')),
  },
  {
    path: 'billing',
    component: asyncComponent(() => import('../Billing')),
  },
  {
    path: 'billing/edit',
    component: asyncComponent(() => import('../Billing/edit')),
  },
  {
    path: 'billing/arca',
    component: asyncComponent(() => import('../Billing/arca')),
  },
  {
    path: 'billable_concepts',
    component: asyncComponent(() => import('../BillableConcepts')),
  },
  {
    path: 'billing/report/:id',
    component: asyncComponent(() => import('../Billing/reportViews/report')),
  },
  {
    path: 'charges_statistics',
    component: asyncComponent(() => import('../Charges/statistics')),
  },
  {
    path: 'settings',
    component: asyncComponent(() => import('../Settings')),
  },
  {
    path: 'settings/usersManagement',
    component: asyncComponent(() => import('../Settings/usersManagement')),
  },
  {
    path: 'settings/settingsSAU',
    component: asyncComponent(() => import('../Settings/settingsSAU')),
  },
  {
    path: 'settings/sectors',
    component: asyncComponent(() => import('../Settings/sectors')),
  },
  {
    path: 'settings/binServices',
    component: asyncComponent(() => import('../Settings/binServices')),
  },
  {
    path: 'settings/solicitudCategorys',
    component: asyncComponent(() => import('../Settings/solicitudCategorys')),
  },
  {
    path: 'settings/ticketCategorys',
    component: asyncComponent(() => import('../Settings/ticketCategorys')),
  },
  {
    path: 'settings/permissions',
    component: asyncComponent(() => import('../Settings/permissions')),
  },
  {
    path: 'settings/mails',
    component: asyncComponent(() => import('../Settings/mails')),
  },
  {
    path: 'settings/webConfigurations',
    component: asyncComponent(() => import('../Settings/webConfigurations')),
  },
  {
    path: 'settings/processFolders',
    component: asyncComponent(() => import('../Settings/processFolders')),
  },
  {
    path: 'settings/faqSettings',
    component: asyncComponent(() => import('../Settings/faqSettings')),
  },
  {
    path: 'settings/imageConfigInterna',
    component: asyncComponent(() => import('../Settings/imageConfigInterna')),
  },
  {
    path: 'settings/notifications',
    component: asyncComponent(() => import('../Settings/notifications')),
  },
  {
    path: 'reports',
    component: asyncComponent(() => import('../Reports')),
  },
  {
    path: 'transits',
    component: asyncComponent(() => import('../Transits')),
  },
  {
    path: 'faq',
    component: asyncComponent(() => import('../Faq')),
  },
  {
    path: 'faq_question/:id',
    component: asyncComponent(() => import('../Faq/Question')),
  },
  {
    path: 'logs',
    component: asyncComponent(() => import('../Logs')),
  },
  {
    path: 'report',
    component: asyncComponent(() => import('../Reports/report')),
  },
  {
    path: 'authCheck',
    component: asyncComponent(() => import('../AuthCheck')),
  },
  {
    path: 'user/:id',
    component: asyncComponent(() => import('../User/profile')),
  },
  {
    path: 'passageMethod/:id',
    component: asyncComponent(() => import('../PassageMethod')),
  },
  {
    path: 'invoices/:id',
    component: asyncComponent(() => import('../Invoices')),
  },
  {
    path: 'debtors',
    component: asyncComponent(() => import('../Debtors')),
  },
  {
    path: 'passageMethodNew/:id',
    component: asyncComponent(() => import('../PassageMethod')),
  },
  {
    path: 'solicitud/:id',
    component: asyncComponent(() => import('../Ticket')),
    exact: true,
  },

  {
    path: 'serviceBIN/:id',
    component: asyncComponent(() => import('../ServiceBIN')),
  },
  {
    path: 'category/:id',
    component: asyncComponent(() => import('../Category')),
  },
  {
    path: 'notification/:id',
    component: asyncComponent(() => import('../Notification')),
  },
  {
    path: 'toll_operator',
    component: asyncComponent(() => import('../TollOperator')),
  },
  {
    path: 'toll_operator/panel',
    component: asyncComponent(() => import('../TollOperator/panel')),
  },
  {
    path: 'toll_operator/schedule/:period',
    component: asyncComponent(() => import('../TollOperator/schedule')),
  },
  {
    path: 'toll_operator/operator',
    component: asyncComponent(() => import('../TollOperator/operator')),
  },
  {
    path: 'toll_operator/holiday',
    component: asyncComponent(() => import('../TollOperator/holiday')),
  },
  {
    path: 'emails',
    component: asyncComponent(() => import('../Emails')),
  },

];
class AppRouter extends Component {
  render() {
    const { url, style } = this.props;
    return (
      <div style={style}>
        {routes.map(singleRoute => {
          const { path, exact, ...otherProps } = singleRoute;
          return (
            <Route
              exact={exact === false ? false : true}
              key={singleRoute.path}
              path={`${url}/${singleRoute.path}`}
              {...otherProps}
            />
          );
        })}
      </div>
    );
  }
}

export default AppRouter;
